import { makeVar } from '@apollo/client';

export const templateNameVar = makeVar('');
